// scroll bar
import 'simplebar/src/simplebar.css';

import ReactDOM from 'react-dom';
// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ApolloProvider } from '@apollo/client';
// contexts
import { SettingsProvider } from './contexts/SettingsContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
//
import App from './App';
import { AuthProvider } from './contexts/JWTContext';
import { client } from './graphql/Server';

// ----------------------------------------------------------------------

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <ApolloProvider client={client}>
    <AuthProvider>
      <HelmetProvider>
        <SettingsProvider>
          <CollapseDrawerProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </CollapseDrawerProvider>
        </SettingsProvider>
      </HelmetProvider>
    </AuthProvider>
  </ApolloProvider>,
  document.getElementById('root')
);
